import React, { Component } from "react";
import DataTable from "../../Utils/GenericUI/DataTable";
import { CALLS_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
import { CALLS_COMMENT_HEADER as header1 } from "../../Utils/StaticData/DashboardHeader";
import TextField from "@material-ui/core/TextField";
import AutoComplete1 from "../../Utils/Select";
import moment from "moment";
import { DataValidation } from "../../Utils/StaticData/Constant";
const defaultrelation = { label: "select", value: "" };
class Calls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      relations: [
        {
          label: "---Select---",
          value: "",
        },
        {
          label: "NIECE/NEPHEW",
          value: "NIECE/NEPHEW",
        },
        {
          label: "OTHER",
          value: "OTHER",
        },
        {
          label: "GRANDFATHER",
          value: "GRANDFATHER",
        },
        {
          label: "ATTORNEY",
          value: "ATTORNEY",
        },
        {
          label: "GRANDPARENT",
          value: "GRANDPARENT",
        },
        {
          label: "STEP PARENT",
          value: "STEP PARENT",
        },
        {
          label: "UNKNOWN",
          value: "UNKNOWN",
        },
        {
          label: "SPOUSE",
          value: "SPOUSE",
        },
        {
          label: "GRANDMOTHER",
          value: "GRANDMOTHER",
        },
        {
          label: "PHYSICIAN",
          value: "PHYSICIAN",
        },
        {
          label: "FOSTER PARENT",
          value: "FOSTER PARENT",
        },
        {
          label: "POWER OF ATTORNEY",
          value: "POWER OF ATTORNEY",
        },
        {
          label: "FATHER",
          value: "FATHER",
        },
        {
          label: "LIFE PARTNER",
          value: "LIFE PARTNER",
        },
        {
          label: "EMPLOYEE",
          value: "EMPLOYEE",
        },
        {
          label: "FOSTER CHILD",
          value: "FOSTER CHILD",
        },
        {
          label: "MOTHER",
          value: "MOTHER",
        },
        {
          label: "GRANDCHILD",
          value: "GRANDCHILD",
        },
        {
          label: "SISTER",
          value: "SISTER",
        },
        {
          label: "BROTHER",
          value: "BROTHER",
        },
        {
          label: "DEPENDENT",
          value: "DEPENDENT",
        },
        {
          label: "NATURAL CHILD",
          value: "NATURAL CHILD",
        },
        {
          label: "GUARDIAN",
          value: "GUARDIAN",
        },
        {
          label: "RELATIVE(OTHER)",
          value: "RELATIVE(OTHER)",
        },
        {
          label: "STEP CHILD",
          value: "STEP CHILD",
        },
        {
          label: "FRIEND",
          value: "FRIEND",
        },
        {
          label: "SELF",
          value: "SELF",
        },
      ],
    };
  }

  render() {
    return (
      <div id="calls" class="tab-pane active display-grid">
        <DataTable
          // width="91%"
          width="100%"
          dashboard="prospectManagement"
          padding="4px 40px 4px 4px"
          data={this.props.tableData}
          header={header}
          //exportAsExcel={true}
          rowsPerPage={this.props.rowsPerPage}
          rowsPerPageOptions={[10, 15, 20]}
          index={this.props.selectedRowIndex}
          handleChangeRowsPerPage={this.props.handleChangeRowsPerPage}
          sortable={true}
          // searchable={true}
          clicked={this.props.rowSelect}
          setClick={(x) => {}}
          identifier="callsTable"
          authorizedrelations={this.props.authorizedrelations}
        />
        <div class="panel-body mt-4 ml-3">
          <div class="row">
            {this.props.newCall ? (
              <div class="col-md-8 ml-0">
                <p class="ml-5">
                  <strong>Add Calls</strong>
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
          {this.props.newCall ? (
            <div class="form-panel2">
              <div class="row">
                <div class="ml-5">
                  <span class="label-container mr1em col-lg-3 col-sm-12 col-md-12">
                    <label class="labelprospect" for="calls_contact_name">
                      First Name
                      <span class="mandatory-field">*</span>
                    </label>
                    <br></br>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      //class="form-control width15"
                      class={
                        this.props.data.contactName === ""
                          ? "error-inputprospect w122px"
                          : "form-control1 w122px"
                      }
                      name="contactName"
                      value={this.props.data.contactName}
                      maxLength="20"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.props.handleChange(event);
                      }}
                      id="calls_contact_name"
                    />
                    {/* <TextField name="contactName"
                      value={this.props.data.contactName}
                      onChange={this.props.handleChange}
                      error={
                        //this.props.callsSaveFlag?
                        this.props.data.contactName === ""}
                      size="small"
                      // className="prospectwidth9"                       
                      label="First Name*" variant="outlined" inputProps={{ style: { width: "9rem" } }} /> */}
                  </span>
                  <span class="label-container mr1em col-lg-3 col-sm-12 col-md-12">
                    <label class="labelprospect" for="calls_lastname">
                      Last Name
                      <span class="mandatory-field">*</span>
                    </label>
                    <br></br>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        this.props.data.lastName === ""
                          ? "error-inputprospect w122px"
                          : "form-control1 w122px"
                      }
                      //class="form-control width15"
                      name="lastName"
                      value={this.props.data.lastName}
                      maxLength="20"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.props.handleChange(event);
                      }}
                      id="calls_lastname"
                    />
                    {/* <TextField name="lastName"
                      value={this.props.data.lastName}
                      onChange={this.props.handleChange}
                      error={
                        //this.props.callsSaveFlag? 
                        this.props.data.lastName === ""}
                      size="small"
                      inputProps={{ style: { width: "9rem" } }}
                      // className="prospectwidth9"                         
                      label="Last Name*" variant="outlined" /> */}
                  </span>
                  <span class="label-container mr1em topn3px col-lg-3 col-sm-12 col-md-12">
                    <label for="call_reln" class="labelprospect">
                      Relationship*
                    </label>
                    <br />
                    {/* <TextField name="relation"
                      value={this.props.data.relation}
                      onChange={this.props.handleChange}
                      error={
                        //this.props.callsSaveFlag?
                        this.props.data.relation === ""}
                      size="small"
                      inputProps={{ style: { width: "9rem" } }}
                      // className="prospectwidth9"                          
                      label="Relationship*" variant="outlined" /> */}
                    <AutoComplete1
                      // label="Relationship*"
                      dashboard="callsrelation"
                      height="7px !important"
                      handleChange={this.props.handleOtherDropdown("relation")}
                      options={this.props?.authorizedrelations}
                      value={
                        this.props?.authorizedrelations?.filter(
                          (data1) => data1.value === this.props.data.relation
                        ).length !== 0
                          ? this.props?.authorizedrelations?.filter(
                              (data1) =>
                                data1.value === this.props.data.relation
                            )[0]
                          : {
                              label: "---Select---",
                              value: "",
                            }
                      }
                      defaultValue={defaultrelation}
                      name="relation"
                      width="222px"
                      error={
                        this.props.data.relation === "" ||
                        this.props.data.relation === "---Select---"
                          ? true
                          : false
                      }
                    />
                  </span>

                  <span class="label-container mr1em col-lg-3 col-sm-12 col-md-12">
                    <label class="labelprospect" for="calls_date_of_call">
                      Date of Call
                    </label>
                    <br></br>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      //class="form-control width10"
                      //class="form-control1dashboard w93"
                      //id="calls_date_of_call"
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("dateOfCall")}
                      value={this.props.data.dateOfCall}
                      maxLength="26"
                      id="dateOfCall"
                      name="dateOfCall"
                      placeholder="MM/DD/YYYY"
                      class={
                        this.props.data.dateOfCall === "" ||
                        !moment(
                          this.props.data.dateOfCall,
                          "MM/DD/YYYY",
                          true
                        ).isValid()
                          ? "error-inputprospect w122px scrollfix"
                          : "form-control1 w122px scrollfix"
                      }
                    />
                    {/* <TextField
                      //  class={
                      //     this.props.data.dateOfCall === "" ||
                      //       !moment(this.props.data.dateOfCall, "MM/DD/YYYY", true).isValid()
                      //     ?  "form-control"
                      //     : "form-control"
                      //     }
                      // class="form-control1dashboard w93"
                      maxLength="10"
                      name="dateOfCall"
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("dateOfCall")}
                      value={this.props.data.dateOfCall}
                      //onChange={this.props.handleChange}
                      //onChange={this.props.handleDate}
                      //onClick={(e) => this.props.handleDates("proposedEffDate")}
                      label="Date of Call" variant="outlined"
                      id="dateOfCall"
                      placeholder="MM/DD/YYYY"
                      size="small"
                      inputProps={{ style: { width: "9rem" } }}
                    /> */}
                  </span>
                  <br></br>
                  <span class="label-container mr1em w-100 col-lg-12 col-sm-12 col-md-12">
                    <label class="labelprospect" for="calls_comment">
                      Comment
                      <span class="mandatory-field">*</span>
                    </label>
                    <br></br>
                    <textarea
                      //class="form-control w-75"
                      class={
                        //this.props.callsSaveFlag?
                        this.props.data.comment === ""
                          ? "error-inputprospect w-80w"
                          : "form-control1 w-80w"
                        // : "form-control1 w-75"
                      }
                      id="calls_comment"
                      name="comment"
                      value={this.props.data.comment}
                      maxLength="1024"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.props.handleChange(event);
                      }}
                      size="10"
                    ></textarea>
                  </span>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        {this.props.isRowSelectedInCalls && !this.props.newCall ? (
          <DataTable
            // width="91%"
            width="100%"
            padding="4px 20px 4px 4px"
            dashboard="prospectManagement"
            data={this.props.commenttableData}
            header={header1}
            //exportAsExcel={true}
            rowsPerPage={this.props.rowsPerPage1}
            rowsPerPageOptions={[10, 15, 20]}
            index={this.props.selectedRowIndexComments}
            handleChangeRowsPerPage={this.props.handleChangeRowsPerPageCmtTable}
            sortable={true}
            //searchable={true}
            clicked={this.props.rowSelectCmt}
            setClick={(x) => {}}
          />
        ) : null}
      </div>
    );
  }
}

export default Calls;
